import React from 'react'
import { IconPropsModel } from '../Icon.model'

export const IconFeedback: React.FC<Partial<IconPropsModel>> = (props) => (
  <svg
    className={props.className || ''}
    style={props.style}
    width="44"
    height="57"
    viewBox="0 0 44 57"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_866_73577)">
      <path
        d="M6.45053 27.7804L7.95052 27.7852L7.95053 27.7851L6.45053 27.7804ZM20.3195 46.5281L20.2832 48.0277C20.3108 48.0283 20.3384 48.0283 20.366 48.0274L20.3195 46.5281ZM26.5857 46.3337L26.5983 44.8337C26.5786 44.8335 26.5589 44.8338 26.5392 44.8344L26.5857 46.3337ZM35.1956 40.5226L33.6958 40.4988L33.6958 40.4989L35.1956 40.5226ZM35.2777 28.6301L33.7778 28.6427L33.7778 28.6428L35.2777 28.6301ZM35.1576 18.9522L36.6575 18.9301L36.6575 18.9301L35.1576 18.9522ZM33.9981 13.6105L34.4579 12.1827L34.4576 12.1826L33.9981 13.6105ZM15.7252 13.6105V12.1105C15.6913 12.1105 15.6575 12.1117 15.6237 12.114L15.7252 13.6105ZM6.46012 20.006L7.96012 20.0053V20.0052L6.46012 20.006ZM4.95054 27.7757C4.938 31.7349 5.0061 37.0346 5.0061 40.7723H8.0061C8.0061 36.9155 7.93782 31.7965 7.95052 27.7852L4.95054 27.7757ZM5.0061 40.7723C5.0061 42.6821 5.08496 44.1833 5.27415 45.238C5.36617 45.7509 5.50465 46.2832 5.74945 46.7247C5.99245 47.1629 6.54117 47.8337 7.50204 47.8337V44.8337C7.77404 44.8337 8.00946 44.9314 8.1738 45.0565C8.31661 45.1653 8.37153 45.267 8.37306 45.2698C8.37704 45.277 8.35684 45.2411 8.32522 45.1369C8.29469 45.0363 8.26072 44.8961 8.22702 44.7083C8.08723 43.929 8.0061 42.6495 8.0061 40.7723H5.0061ZM7.50204 47.8337C9.25186 47.8337 12.2458 47.8335 20.2832 48.0277L20.3557 45.0286C12.295 44.8338 9.27685 44.8337 7.50204 44.8337V47.8337ZM20.366 48.0274L26.6323 47.8329L26.5392 44.8344L20.2729 45.0288L20.366 48.0274ZM26.5731 47.8336C29.3785 47.8572 31.0164 47.6038 32.1439 47.3138C32.6789 47.1762 33.1205 47.0218 33.3641 46.946C33.63 46.8632 33.7137 46.8543 33.7766 46.8543V43.8543C33.2515 43.8543 32.8191 43.9736 32.4724 44.0816C32.1033 44.1965 31.8357 44.2954 31.3967 44.4084C30.5761 44.6194 29.2064 44.8556 26.5983 44.8337L26.5731 47.8336ZM33.7766 46.8543C34.4361 46.8543 35.0194 46.5808 35.4552 46.1181C35.8466 45.7027 36.0784 45.1815 36.2306 44.6865C36.5338 43.7003 36.6674 42.3136 36.6954 40.5464L33.6958 40.4989C33.6686 42.2177 33.5346 43.2468 33.363 43.805C33.2778 44.0822 33.2205 44.1153 33.2715 44.0611C33.3671 43.9597 33.559 43.8543 33.7766 43.8543V46.8543ZM36.6954 40.5465C36.7504 37.0808 36.801 31.3816 36.7777 28.6174L33.7778 28.6428C33.8008 31.3697 33.7507 37.0398 33.6958 40.4988L36.6954 40.5465ZM36.7777 28.6175C36.7537 25.7618 36.7014 21.9139 36.6575 18.9301L33.6578 18.9743C33.7017 21.9574 33.7539 25.7972 33.7778 28.6427L36.7777 28.6175ZM36.6575 18.9301C36.6369 17.5345 36.5807 16.166 36.3894 15.086C36.2944 14.5495 36.1509 13.9901 35.9074 13.5058C35.6675 13.0285 35.2296 12.4312 34.4579 12.1827L33.5383 15.0383C33.2332 14.9401 33.1685 14.7368 33.227 14.8532C33.282 14.9626 33.3623 15.1967 33.4354 15.6092C33.5803 16.4273 33.6372 17.5794 33.6578 18.9743L36.6575 18.9301ZM34.4576 12.1826C33.5076 11.877 32.4867 11.9047 30.7928 11.9543C29.0047 12.0066 26.1756 12.1105 21.3001 12.1105V15.1105C26.225 15.1105 29.0948 15.0052 30.8805 14.953C32.7604 14.898 33.1882 14.9257 33.5387 15.0384L34.4576 12.1826ZM21.3001 12.1105H15.7252V15.1105H21.3001V12.1105ZM15.6237 12.114C10.3857 12.4691 8.65105 12.5862 7.59887 12.5862V15.5862C8.78319 15.5862 10.6673 15.4569 15.8267 15.1071L15.6237 12.114ZM7.59887 12.5862C6.46824 12.5862 5.90227 13.4706 5.68743 13.9144C5.44104 14.4234 5.29956 15.0414 5.20661 15.6304C5.01596 16.8386 4.95926 18.4164 4.96012 20.0068L7.96012 20.0052C7.95928 18.4439 8.01785 17.0619 8.16994 16.0981C8.24837 15.6011 8.33514 15.3301 8.38767 15.2216C8.47175 15.0479 8.2754 15.5862 7.59887 15.5862V12.5862ZM4.96012 20.0067C4.96121 22.2153 4.95951 24.9188 4.95054 27.7757L7.95053 27.7851C7.95951 24.9237 7.96121 22.2164 7.96012 20.0053L4.96012 20.0067Z"
        fill={props.fill || '#222222'}
      />
      <rect
        x="25.6106"
        y="33.2196"
        width="10.6833"
        height="25.3032"
        transform="rotate(-150 25.6106 33.2196)"
        fill={props.fill || '#222222'}
      />
      <path
        d="M38.6799 10.5832L29.4279 5.24158C30.7865 2.8885 33.7954 2.08227 36.1485 3.44082L36.8792 3.86271C39.2323 5.22127 40.0385 8.23014 38.6799 10.5832Z"
        fill={props.fill || '#222222'}
      />
      <path
        d="M15.1246 33.368C15.0956 32.115 16.0041 29.2442 16.4272 27.8218L25.5906 32.9618C25.7308 32.8826 25.8109 32.9877 25.0099 34.042C24.2088 35.0963 22.1986 37.2742 21.2936 38.2314C20.4635 38.8679 18.6251 40.1998 17.9127 40.4355C17.0223 40.7303 16.6326 40.366 15.8685 39.3365C15.1044 38.307 15.1609 34.9344 15.1246 33.368Z"
        fill={props.fill || '#222222'}
      />
    </g>
    <defs>
      <filter
        id="filter0_d_866_73577"
        x="0.948975"
        y="2.78088"
        width="42.3909"
        height="53.2473"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_866_73577"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_866_73577"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
)
